import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-317efd12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-event-container" }
const _hoisted_2 = { class: "header-actions" }
const _hoisted_3 = { class: "event-actions" }
const _hoisted_4 = {
  key: 0,
  class: "loading"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading event data...", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "error-message"
}
const _hoisted_8 = {
  key: 2,
  class: "event-content"
}
const _hoisted_9 = { class: "event-header" }
const _hoisted_10 = { class: "event-details" }
const _hoisted_11 = { class: "detail-section" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Basic Information", -1))
const _hoisted_13 = { class: "detail-row" }
const _hoisted_14 = { class: "detail-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Calendar", -1))
const _hoisted_16 = { class: "detail-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Type", -1))
const _hoisted_18 = {
  key: 0,
  class: "detail-item full-width"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Description", -1))
const _hoisted_20 = { class: "detail-section" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Date and Time", -1))
const _hoisted_22 = { class: "detail-row" }
const _hoisted_23 = { class: "detail-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Start Date", -1))
const _hoisted_25 = { class: "detail-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "End Date", -1))
const _hoisted_27 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_28 = { class: "detail-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Start Time", -1))
const _hoisted_30 = { class: "detail-item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "End Time", -1))
const _hoisted_32 = { class: "detail-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Affects Attendance", -1))
const _hoisted_34 = {
  key: 0,
  class: "detail-section"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Recurrence", -1))
const _hoisted_36 = { class: "detail-item" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Recurrence Pattern", -1))
const _hoisted_38 = {
  key: 1,
  class: "detail-section"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Bell Schedule", -1))
const _hoisted_40 = { class: "bell-schedule" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Period"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Time"),
    /*#__PURE__*/_createElementVNode("th", null, "End Time"),
    /*#__PURE__*/_createElementVNode("th", null, "Duration")
  ])
], -1))
const _hoisted_42 = { class: "detail-section" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Additional Information", -1))
const _hoisted_44 = { class: "detail-row" }
const _hoisted_45 = { class: "detail-item" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Created", -1))
const _hoisted_47 = { class: "detail-item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Last Updated", -1))
const _hoisted_49 = {
  key: 3,
  class: "modal-overlay"
}
const _hoisted_50 = { class: "modal-content" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Confirm Delete", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "warning" }, "This action cannot be undone.", -1))
const _hoisted_53 = { class: "modal-actions" }

import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import { API_URL } from "../config";
import { getErrorMessage } from "../types";
import type { CalendarEventRecord } from "../types";

// Router and Route

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewEventView',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const calendarId = route.params.calendarId as string;
const eventId = route.params.eventId as string;

// State
const event = ref<CalendarEventRecord | Record<string, never>>({});
const calendarName = ref("");
const loading = ref(true);
const error = ref("");
const showDeleteModal = ref(false);

// Format functions
const formatDate = (dateString: string): string => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Date";

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long",
  });
};

const formatTime = (timeString: string): string => {
  if (!timeString) return "N/A";

  // Convert 24-hour format to 12-hour format
  const [hours, minutes] = timeString.split(":");
  const hour = parseInt(hours, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;

  return `${hour12}:${minutes} ${ampm}`;
};

const formatDateTime = (dateTimeString: string): string => {
  if (!dateTimeString) return "N/A";

  const date = new Date(dateTimeString);
  if (isNaN(date.getTime())) return "Invalid Date";

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

const formatEventType = (type: string): string => {
  if (!type) return "";

  // Convert snake_case to Title Case
  return type
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const formatPeriodType = (type: string): string => {
  if (!type) return "Regular";

  return type.charAt(0).toUpperCase() + type.slice(1);
};

const formatRecurrencePattern = (pattern: string): string => {
  if (!pattern) return "Not specified";

  const patterns: { [key: string]: string } = {
    daily: "Daily",
    weekly: "Weekly",
    biweekly: "Every two weeks",
    monthly: "Monthly",
    yearly: "Yearly",
  };

  return patterns[pattern] || pattern;
};

const calculateDuration = (startTime: string, endTime: string): string => {
  if (!startTime || !endTime) return "N/A";

  const [startHours, startMinutes] = startTime.split(":").map(Number);
  const [endHours, endMinutes] = endTime.split(":").map(Number);

  let durationMinutes =
    endHours * 60 + endMinutes - (startHours * 60 + startMinutes);

  // Handle cases where end time is on the next day
  if (durationMinutes < 0) {
    durationMinutes += 24 * 60;
  }

  const hours = Math.floor(durationMinutes / 60);
  const minutes = durationMinutes % 60;

  if (hours === 0) {
    return `${minutes} minutes`;
  } else if (minutes === 0) {
    return `${hours} hour${hours !== 1 ? "s" : ""}`;
  } else {
    return `${hours} hour${hours !== 1 ? "s" : ""} ${minutes} minute${
      minutes !== 1 ? "s" : ""
    }`;
  }
};

// Functions
const fetchEvent = async () => {
  loading.value = true;
  try {
    const response = await axios.get(
      `${API_URL}/calendar/${calendarId}/events/${eventId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    event.value = response.data;

    // Fetch calendar name
    const calendarResponse = await axios.get(
      `${API_URL}/calendar/${calendarId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    calendarName.value = calendarResponse.data.name;
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to fetch event");
    console.error("Error fetching event:", err);
  } finally {
    loading.value = false;
  }
};

const editEvent = () => {
  router.push(`/calendar/${calendarId}/events/${eventId}/edit`);
};

const confirmDelete = () => {
  showDeleteModal.value = true;
};

const deleteEvent = async () => {
  try {
    await axios.delete(`${API_URL}/calendar/${calendarId}/events/${eventId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    // Navigate back to events list
    router.push(`/calendar/${calendarId}/events`);
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to delete event");
    console.error("Error deleting event:", err);
  }
};

const goBack = () => {
  router.push(`/calendar/${calendarId}/events`);
};

// Lifecycle hooks
onMounted(() => {
  fetchEvent();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn-back",
        onClick: goBack
      }, [
        _createVNode(_unref(FontAwesomeIcon), { icon: "arrow-left" }),
        _createTextVNode(" Back to Events ")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn-edit",
          onClick: editEvent
        }, [
          _createVNode(_unref(FontAwesomeIcon), { icon: "edit" }),
          _createTextVNode(" Edit Event ")
        ]),
        _createElementVNode("button", {
          class: "btn-delete",
          onClick: confirmDelete
        }, [
          _createVNode(_unref(FontAwesomeIcon), { icon: "trash" }),
          _createTextVNode(" Delete Event ")
        ])
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(error.value), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("h1", null, _toDisplayString(event.value.title), 1),
              _createElementVNode("span", {
                class: _normalizeClass(["event-type", event.value.type])
              }, _toDisplayString(formatEventType(event.value.type)), 3)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("p", null, _toDisplayString(calendarName.value), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("p", null, _toDisplayString(formatEventType(event.value.type)), 1)
                  ])
                ]),
                (event.value.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("p", null, _toDisplayString(event.value.description), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("p", null, _toDisplayString(formatDate(event.value.startDate)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("p", null, _toDisplayString(event.value.endDate
                    ? formatDate(event.value.endDate)
                    : "Same as start date"), 1)
                  ])
                ]),
                (event.value.startTime || event.value.endTime)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("p", null, _toDisplayString(event.value.startTime
                    ? formatTime(event.value.startTime)
                    : "Not specified"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createElementVNode("p", null, _toDisplayString(event.value.endTime ? formatTime(event.value.endTime) : "Not specified"), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("p", null, _toDisplayString(event.value.affectsAttendance ? "Yes" : "No"), 1)
                ])
              ]),
              (event.value.isRecurring)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("p", null, _toDisplayString(formatRecurrencePattern(event.value.recurrencePattern)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (event.value.type === 'bell_schedule' && event.value.bellSchedule)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("table", null, [
                        _hoisted_41,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.value.bellSchedule.periods, (period, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(period.name), 1),
                              _createElementVNode("td", null, _toDisplayString(formatPeriodType(period.type)), 1),
                              _createElementVNode("td", null, _toDisplayString(formatTime(period.startTime)), 1),
                              _createElementVNode("td", null, _toDisplayString(formatTime(period.endTime)), 1),
                              _createElementVNode("td", null, _toDisplayString(calculateDuration(period.startTime, period.endTime)), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("p", null, _toDisplayString(formatDateTime(event.value.createdAt)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("p", null, _toDisplayString(formatDateTime(event.value.updatedAt)), 1)
                  ])
                ])
              ])
            ])
          ])),
    (showDeleteModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            _createElementVNode("p", null, "Are you sure you want to delete the event \"" + _toDisplayString(event.value.title) + "\"?", 1),
            _hoisted_52,
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("button", {
                class: "btn-cancel",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showDeleteModal.value = false))
              }, " Cancel "),
              _createElementVNode("button", {
                class: "btn-confirm-delete",
                onClick: deleteEvent
              }, " Delete ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})